"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfStudentOutput = instanceOfStudentOutput;
exports.StudentOutputFromJSON = StudentOutputFromJSON;
exports.StudentOutputFromJSONTyped = StudentOutputFromJSONTyped;
exports.StudentOutputToJSON = StudentOutputToJSON;
var Metadata_1 = require("./Metadata");
var Student_1 = require("./Student");
/**
 * Check if a given object implements the StudentOutput interface.
 */
function instanceOfStudentOutput(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function StudentOutputFromJSON(json) {
    return StudentOutputFromJSONTyped(json, false);
}
function StudentOutputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(Student_1.StudentFromJSON)),
        'metadata': json['metadata'] == null ? undefined : (0, Metadata_1.MetadataFromJSON)(json['metadata']),
    };
}
function StudentOutputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(Student_1.StudentToJSON)),
        'metadata': (0, Metadata_1.MetadataToJSON)(value['metadata']),
    };
}
